export type center = "center";
export type left   = "left";
export type right  = "right";

//  export\s*type\s*((?:\w|_)+)\s*=\s*"(.+?)";
//    $1 |

export type CSSTextAlignType = 
  center |
  left |
  right
;

export class CSSTextAlign
{
  //  export\s*type\s*((?:\w|_)+)\s*=\s*"(.+?)";
  //  static readonly $1:$1 = "$2";

  static readonly center:center = "center";
  static readonly left:left = "left";
  static readonly right:right = "right";
  
}